//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import XCell from 'bh-mint-ui2/packages/cell/index.js';

export default {
  name: 'mt-radiobox',
  data() {
    return {
      radioClass:''
    }
  },
  props: {
    value: {},
    disabled: Boolean,
    align: String,
    name: [String, Number],
    iconpattern:{
      type:String,
      default:"circle"
    },
    isLink:{
      type: Boolean,
      default: false
    },
    direction:{
      type: String,
      default: "vertical"
    },
    valueAlign: {
      type: String,
      default: "flex-start"
    },
    required:{
      type:Boolean,
      default:false
    },
    wrapperpaddingleft:{
      type:String,
      default:"20px"
    },
    options:{
      type:Array,
      default:function(){
        return []
      }
    }
  },
  components: { XCell },

  computed: {
    // whether is in mint-checkbox-group
    isGroup() {
      return !!this.findParentByName('mt-box-group');
    },
    currentValue: {
      get() {
        let currentValue=this.isGroup && this.parentGroup ? this.parentGroup.value : this.value;
        return currentValue;
      },
      set(val) {
        if (this.isGroup && this.parentGroup) {
          this.parentGroup.$emit('input', val);
        } else {
          this.$emit('input', val);
        }
      }
    },

    isDisabled() {
      if (this.isGroup && this.parentGroup) {
        return this.parentGroup.disabled || this.disabled;
      } else {
        return this.disabled;
      }
    }
  },

  methods: {
    handleLabelClick() {
      if (!this.isDisabled) {
        this.currentValue = !this.currentValue;
      }
    },
    handleRadioClick(e) {
      //if(!this.currentValue){
        this.$emit('radiobox-click',e,this.name);
      //}
    },
    findParentByName(name) {
      if (!this.parentGroup) {
        let parent = this.$parent;
        while (parent) {
          if (parent.$options.name === name) {
            this.parentGroup = parent;
            break;
          }
          parent = parent.$parent;
        }
      }

      return this.parentGroup;
    }
  }

};



// WEBPACK FOOTER //
// ./packages/radiobox/src/radiobox.vue